import type { LegalCaseRisk } from '../../../../types/LegalCase';

// Helpers puros do risco CPC 25 no detalhe do caso (ADR 003). O backend já entrega os valores
// calculados (perda estimada, provisão calculada/efetiva, flags); aqui ficam só as decisões de
// apresentação, testáveis isoladamente e fora de qualquer componente.

// Um bloco de risco tem conteúdo quando ao menos a classificação ou o percentual foi informado.
// Type guard (`is LegalCaseRisk`): ao passar no if, o TS estreita `risk` para não-nulo, então o
// card renderiza os campos sem non-null assertion.
export const hasRiskData = (risk: LegalCaseRisk | null | undefined): risk is LegalCaseRisk => {
    if (!risk) return false;
    return risk.cpc25Classification !== null || risk.estimatedLossPercent !== null;
};

// Cor do selo por classificação: provável = vermelho (provisiona/maior risco), possível = âmbar,
// remota = verde, não se aplica/nada = neutro.
export const classificationBadgeClass = (classification: string | null): string => {
    if (classification === 'PROBABLE') return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300';
    if (classification === 'POSSIBLE') return 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300';
    if (classification === 'REMOTE') return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300';
    return 'bg-gray-100 text-gray-700 dark:bg-slate-700 dark:text-gray-300';
};

// A provisão é reconhecida (CPC 25) quando há valor efetivo > 0. Usado para dar destaque.
export const hasProvision = (risk: LegalCaseRisk): boolean => risk.provisionAmount > 0;

// O percentual foge do padrão sugerido para a classificação (só quando dá para comparar).
export const isOffSuggestion = (risk: LegalCaseRisk): boolean =>
    risk.lossPercentMatchesSuggestion === false;
